// services/authService.js

import { logout } from "../../Actions/Users";
import { checkedDevelopmentType, setCookie } from "../../Helpers";
import { apiFetch } from "../../Utils/apiFetch";


export async function loginUser(email, password) {
  const fetchUrl = checkedDevelopmentType();
  const body = new URLSearchParams(
    `email=${email}&password=${password}&app=2bd5bd10345cd1555b14c221ec6e8647c46ee21e8ee45312${fetchUrl}`
  );

  const response = await apiFetch("/api/session", {
    method: "POST",
    body,
  });

  return response;
}

export async function fetchAccounts(accountId) {
  const response = await apiFetch(`/api/accounts?accountId=${accountId}`);
  return response.json();
}

export async function fetchPrivileges(userInfo) {
  let url =
    userInfo.userType === -1
      ? `/api/privileges?roleId=${userInfo.roleId}&all=true`
      : `/api/privileges?roleId=${userInfo.roleId}`;

  const response = await apiFetch(url, { method: "GET" });
  return response.json();
}

export function clearSession(dispatch, navigate) {
  apiFetch("/api/session", { method: "DELETE" })
    .then((res) =>
      res.json().then((response) => {
        if (response.status === "success" || response.statusCode) {
          navigate("/login");
          localStorage.clear();
          dispatch(logout());
          setCookie("JSESSIONID", 0);
        }
      })
    )
    .catch(() => {
      navigate("/login");
      localStorage.clear();
      dispatch(logout());
      setCookie("JSESSIONID", 0);
    });
}
